import React from 'react';
import PropTypes from 'prop-types';
import './Diagonal.css';

const Diagonal = (props) => {
  const { colors } = props;

  return (
    <div className="diagonal-block">
      {colors.map((color, index) => (
        <div
          className={`bg bg${index ? index + 1 : ''}`}
          style={{
            backgroundImage: `linear-gradient(-60deg, ${colors[0]} 50%, ${colors[2]} 50%)`
          }}
          key={color.toString()}
        />
      ))}
    </div>
  );
};

Diagonal.propTypes = {
  colors: PropTypes.array,
};

export default Diagonal;
